import "./plugins/prototype";

import Vue from "vue";
import axios from "axios";
import VueMeta from "vue-meta";
import api from "./api";
import { ClientRouter as router } from "./router";
import store from "./store";
import vuetify, { basicTheme } from "./plugins/vuetify";
import "./plugins/vue-cookies";
import "./plugins/vue-dayjs";
import "./plugins/vue-excel";
import "./plugins/vue-meta";
import "./plugins/vue-message-dialog";
// import "./styles/override.css";
import "./plugins/kcp/pay";

import App from "./AppMain.vue";
Vue.prototype.$http = axios;
Vue.config.productionTip = false;

if (process.env.NODE_ENV == "production" && location.protocol != "https:" && location.hostname == "daehanbooks.co.kr") location.protocol = "https:";
if (process.env.NODE_ENV == "production" && location.pathname.indexOf("/child") > -1 && location.pathname.indexOf("/children") === -1) window.location.href = "https://www.daehanbooks.co.kr";

api.v1.theme.get().then(({ theme: siteTheme }) => {
    Vue.prototype.$theme = siteTheme || basicTheme;

    new Vue({
        router,
        store,
        vuetify: vuetify({
            ...(siteTheme || basicTheme),
            options: { customProperties: true },
        }),
        VueMeta,
        render: (h) => h(App),
    }).$mount("#app");
});
